import React, { Component } from 'react'
import { get } from "lodash"

import {
  getValidateNameMessage,
  checkIsValidName,
  isFailureNameValidation,
} from "./static.nameData"

import { withStepsState } from "../../../shared/containers/containerStepsState"

import ButtonFill from "../../../shared/items/controls/buttonFill"

class NameNextStepButton extends Component {
  componentDidUpdate() {
    const { data, onSetSuccessValidate, onSetFailValidate } = this.props

    if (checkIsValidName(data))
      onSetSuccessValidate("name")

    if (isFailureNameValidation(data))
      onSetFailValidate("name", getValidateNameMessage(get(data, ["name", "value"], null)))
  }

  render() {
    const { data, onToNextStep } = this.props

    return (
      <ButtonFill disabled={!get(data, ["name", "isValid"], false)} onClick={onToNextStep}>
        {this.props.children}
      </ButtonFill>
    )
  }
}

export default withStepsState(NameNextStepButton)